export default __webpack_public_path__ + "static/media/wheel-b.5d67469b.webp";